import { Box } from '@mui/material';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Stepper from '@mui/material/Stepper';

import { IEnrollmentStep } from 'src/interfaces';

type Props = {
  activeStep: number;
  steps: IEnrollmentStep[];
  handleStep: (step: IEnrollmentStep) => void;
};

const EnrollmentStepBar = ({ steps, activeStep, handleStep }: Props) => (
  <Box sx={{ width: '100%', mt: '20px', display: { lg: 'block', xs: 'none' } }}>
    <Stepper activeStep={activeStep}>
      {steps.map((step) => (
        <Step
          key={step.key}
          sx={{
            '&': {
              padding: 0,
            },
            '& .MuiStepLabel-iconContainer': {
              padding: 0,
            },
            '& .Mui-active': {
              fontWeight: 'bold',
            },
            '& .Mui-disabled .MuiSvgIcon-root': {
              color: '#EEEEEE',
            },
            '& .Mui-disabled .MuiSvgIcon-root text': {
              fill: 'black',
              opacity: 0.38,
            },
            '& .MuiStepLabel-root svg': {
              width: '50px',
              height: '50px',
            },
          }}
        >
          <StepButton color="inherit" onClick={() => handleStep(step)} />
        </Step>
      ))}
    </Stepper>
  </Box>
);

export default EnrollmentStepBar;
